import { CircularProgress, Image } from "@chakra-ui/react";
import gifJaeBus from "assets/img/gif-jae-bus.gif";

interface LoadingSpinnerProps {
  size?: string;
  color?: string;
}

/**
 * Componente de loading centralizado.
 * - Tenant "Jae": exibe o gif animado gif-jae-bus.gif
 * - Demais tenants: exibe o CircularProgress padrão do Chakra UI
 */
export default function LoadingSpinner({
  size = "100px",
  color = "green.300",
}: LoadingSpinnerProps) {
  if (window.config.tenant === "Jaee") {
    return (
      <Image
        src={gifJaeBus}
        w={"130px"}
        h={"130px"}
        objectFit="contain"
        alt="Carregando..."
      />
    );
  }

  return <CircularProgress isIndeterminate color={color} size={size} />;
}
